import type * as React from "react"

import type { VoiceStageBackground } from "./voice-stage-utils"

import styles from "./voice-stage.module.css"

type VoiceGroundProps = {
  background: VoiceStageBackground
}

/**
 * The ground the window sits on. The brand's sky by default; a tenant can set
 * a flat colour or their own image in branding. The focus pull (blur to sharp
 * as the assistant speaks) is driven by the stage's `data-state` and applies
 * to images; a flat colour has nothing to focus. The layer clips itself so
 * the window can let its edge labels hang outside.
 */
export function VoiceGround({ background }: VoiceGroundProps) {
  let style: React.CSSProperties | undefined
  if (background.mode === "color") style = { backgroundColor: background.color }
  if (background.mode === "image") style = { backgroundImage: `url("${background.url}")` }

  return (
    <div aria-hidden="true" className={styles.groundClip}>
      <div
        className={styles.ground}
        data-bg={background.mode}
        data-testid="voice-ground"
        style={style}
      />
    </div>
  )
}
